import { useEffect, useState } from 'react';
import _local from 'utils/localStorageUtils';

const useAuthRole = (allowedRoles = ['admin']) => {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const localUser = _local.getLocalUser();
    setIsAllowed(allowedRoles.includes(localUser?.role));
  }, [allowedRoles]);

  return isAllowed;
};

export default useAuthRole;